<div class="row">
	<p class="col-sm-3 ordina_data">
	  <label for="cerca-sogg-terz-list">Cerca</label> <input id="cerca-sogg-terz-list" type="text" #searchItem (keyup)="0"
		class="form-control" placeholder="Inserisci nome e cognome" />
	</p>
	<p class="col-sm-3 col-md-offset-6">
	  <label for="ordina_data-sogg-terzi">Ordina per:</label> <select id="ordina_data-sogg-terzi" class="form-control"
		#orderByValue (change)="0">
		<!-- <option value="option.dataAssociazione:ASC">Data Associazione</option> -->
		<option value="option.dataTermine:ASC">Data rinuncia</option>
		<option value="option.parte.nominativo:ASC">Nome</option>
	  </select>
	</p>
</div>
<ul class="controparti m0">
  <li class="panel" *ngFor="let soggetto of soggetti | searchFilter : searchItem.value :'option.parte.nominativo' | orderBy : orderByValue.value; let indice = index">
    <div class="data_opzioni menu">
      <ul>

        <li *ngIf="writable" class="opzioni" appDropdownFocus><a class="dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
            aria-expanded="false">Opzioni<span class="glyphicon glyphicon-option-vertical"></span></a>
          <div class="dropdown-menu">
            <ul>
              <li>
                <span class="glyphicon glyphicon-paperclip"></span>
                <a href="javascript:void(0);" (click)="displayAddDocModal(soggetto.option)">
                  Allega documento
                </a>
              </li>
              <li>
                <span class="glyphicon glyphicon-ban-circle"></span>
                <a href="javascript:void(0)" (click)="disattivaAltraParte(soggetto.option)">
                  Disattiva
                </a>
              </li>

              <li><span class="glyphicon glyphicon-trash"></span>
                <a href="javascript:void(0)" (click)="eliminaAltraParte(soggetto.option)">
                  Elimina
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <div class="controparte">
      <div>
					<a
						href="#"
						role="button"
						class="collapsed"
						[class.accordion-collapse]="activeIndex === indice"
						[class.accordion-collapsed]="activeIndex !== indice"
						[attr.aria-expanded]="activeIndex === indice"
						[attr.aria-controls]="'labelComponent' + indice"
						id="accordion-header-sogg-list-{{indice}}"
						(click)="openDetail(soggetto, indice); $event.preventDefault()">
							<span aria-live="polite" class="sr-only">{{ activeIndex === indice ? 'Chiudi dettaglio' : 'Apri dettaglio' }}</span>
					</a>

        <p class="col-sm-2 button-associa">
          <button class="btn btn-danger associa" (click)="disassocia(soggetto.option)">Disassocia</button>
        </p>
        <h4 class="titolo col-sm-4 mt-5"
          *ngIf="soggetto.option.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
          <a data-toggle="collapse" (click)="openDetail(soggetto, indice)" aria-expanded="false"
            [attr.aria-controls]="labelComponent + indice"
            data-parent="#controparticollapse">{{soggetto.option.parte.cognome}}
            {{soggetto.option.parte.nome}}</a>
        </h4>
        <h4 class="titolo col-sm-4 mt-5"
          *ngIf="soggetto.option.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
          <a data-toggle="collapse" (click)="openDetail(soggetto, indice)" aria-expanded="false"
            [attr.aria-controls]="labelComponent + indice"
            data-parent="#controparticollapse">{{soggetto.option.parte.ragioneSociale}}</a>
        </h4>
        <p class="col-sm-3 matricola mt-5"
          *ngIf="soggetto.option.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
          C/F: <strong>{{soggetto.option.parte.codiceFiscale}}</strong>
        </p>
        <p class="col-sm-3 matricola mt-5"
          *ngIf="soggetto.option.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
          P.IVA: <strong>{{soggetto.option.parte.partitaIva}}</strong>
        </p>
        <ng-template [ngIf]="soggetto.option.ritirato">
          <p class="col-sm-2 mt-5 status">NON ATTIVO</p>
        </ng-template>
        <p class="col-sm-2 matricola mt-5" *ngIf="soggetto.option.parte.id?.startsWith('TEMP')">
          <span class="label label-success">Nuova anagrafica</span>
        </p>

      </div>
    </div>
    <ul class="{{activeIndex === indice ? 'collapsed' : 'collapse'}} subcontroparte">
      <li>
        <div class="container_dati_generali">
          <div class="container_tab_nav" *ngIf="soggetto.option.categoriaAltraParte != null">

          <ul class="nav nav-tabs two" role="tablist">
            
            <!-- TAB ASSOCIATIVA -->
            <li role="presentation" class="tab-link-nav" [style.width.%]="50">
              <button
                type="button"
                role="tab"
                id="tab-associativa-sogg"
                class="btn-link"
                aria-controls="panel-associativa"
                [attr.aria-selected]="currentTab === 'ASSOCIATIVA'"
                [class.active]="currentTab === 'ASSOCIATIVA'"
                [class.inactive]="currentTab !== 'ASSOCIATIVA'"
                (click)="setTab('ASSOCIATIVA')"
                style="cursor: pointer; width: 100%;">
                Associativa
              </button>
            </li>

            <!-- TAB ANAGRAFICA -->
            <li role="presentation" class="tab-link-nav" [style.width.%]="50">
              <button
                type="button"
                role="tab"
                id="tab-anagrafica-sogg"
                class="btn-link"
                aria-controls="panel-anagrafica"
                [attr.aria-selected]="currentTab === 'ANAGRAFICA'"
                [class.active]="currentTab === 'ANAGRAFICA'"
                [class.inactive]="currentTab !== 'ANAGRAFICA'"
                (click)="setTab('ANAGRAFICA')"
                style="cursor: pointer; width: 100%;">
                Anagrafica
              </button>
            </li>
          </ul>

          </div>
          <div *ngIf="currentTab == 'ASSOCIATIVA'" style="padding: 30px 0">
            <div *ngIf="!editingParte">
              <app-associativa-soggetti-terzi [altraParte]="soggetto.option"></app-associativa-soggetti-terzi>
            </div>
            <div *ngIf="editingParte">
              <step-soggetti-terzi-form-associativa 
                [parte]="soggetto.option.parte" 
                [altraParte]="soggetto.option"
                (altraParteChange)="retrieveParte($event , soggetto.option )" 
                (altraParteEdit)="editParte($event)" 
                [suggestedCategory]="soggetto.categoria">
              </step-soggetti-terzi-form-associativa>
            </div>
          </div>
          <div *ngIf="currentTab == 'ANAGRAFICA'" style="padding: 30px 0">
            <div *ngIf="!editingParte">
              <app-dati-generali-anagrafiche-search  
                [option]="{ hasDetailsAnagrafica: false, anagrafica: soggetto.option.parte}"
                [isLegale]="false" 
                [isPartiSearch]="true" 
                [isControparte]="false">
              </app-dati-generali-anagrafiche-search>
            </div>
            <div *ngIf="editingParte">
              <anagrafica-parte-form
                [isParteForm]="true"
                (parteChange)="onEmitUpdateAnagrafica($event, soggetto.option)"
                [parte]="soggetto.option.parte">
              </anagrafica-parte-form>
            </div>
          </div>

        </div>
      </li>
      <div *ngIf="!editingParte" class="row">
        <p class="col-sm-3 col-sm-offset-9 col-xs-3 col-xs-offset-9">
          <button type="button" class="btn btn-primary btn-block"
            (click)="editingParte = true">Modifica dati</button>
  
          </p>
        </div>
        <div *ngIf="editingParte" class="row">
          <p class="col-sm-3 col-sm-offset-9 col-xs-3 col-xs-offset-9">
          <button type="button" class="btn btn-secondary btn-block"
            (click)="editingParte = false">Annulla</button>
        </p>
      </div>
      <div class="">
        <ng-template [ngIf]="soggetto.option && soggetto.option.documenti && soggetto.option.documenti.length > 0">
          <p>Documentazione allegata</p>
          <ul documenti_allegati_lista=""
            [documenti]="soggetto.option.documenti" [subdoc]="false"
            [writable]="writable"
            [nomeCampoId]="nomeCampoId"
            [fascicolo]="fascicolo"
            (onReturn)="onReturnUpdateCallback($event)"
            (openModal)="showUploadNewVersionModal($event)"
            (openHistoryModal)="showHistoryModal($event)"
            (removDoc)="removeDoc($event, soggetto.option.id, sezione.id)"
            (onOpenUpdateMetadatiModal)="displayDocUpdateMetadatiModal($event)">
          </ul>
        </ng-template>
      </div>
    </ul>
  </li>
</ul>
